import localStorer, { CURRENT_WELL } from './localStorer';

export type CurrentWellInStorage = { wellId?: string; tuwi?: string };

export const getCurrentWellInLocalStorage = (): CurrentWellInStorage => {
  const currentWellInStorageValue = localStorer.get(CURRENT_WELL);
  if (!currentWellInStorageValue) return {};
  try {
    return JSON.parse(currentWellInStorageValue) as CurrentWellInStorage;
  } catch (error) {
    return {};
  }
};

export const setCurrentWellInLocalStorage = (wellIdAndTuwi: CurrentWellInStorage) =>
  localStorer.set(CURRENT_WELL, JSON.stringify(wellIdAndTuwi));
